// Auto generated by ControleTool.ModelClassGenerator
import { inject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { Helpers } from '../services/helpers';
import { AnswerLogViewModel } from './answerlogview-model';


export class StudentStoredAnswersViewModel {
    studentId: string = null;
	storedAnswers: AnswerLogViewModel[] = null;
	
	constructor(data: any = null) {
        
		if (data) {
			Helpers.mapProperties(data, this);
        }
        
	}
}